<template>
    <div class="extra-info">
        <div
            v-if="extraInfo"
            v-html="extraInfo"
        ></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            extraInfo: null,
        };
    },
    created() {
        const loading = this.$loading({
            lock: true,
            text: "正在跳转到支付页面，请稍后......",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0)",
            customClass: "extra-info-loading-icon",
        });
        this.extraInfo = sessionStorage.getItem("bosiExtraInfo");
        this.$nextTick(() => {
            loading.close();
            document.all.pay_form.submit();
        });
    },
};
</script>

<style>
.extra-info-loading-icon {
    font-size: 70px;
}

.extra-info-loading-icon .el-loading-text {
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pay/bosiExtraInfo.vue